import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=5c2d25e2&scoped=true"
import script from "./GiftCard.vue?vue&type=script&lang=js"
export * from "./GiftCard.vue?vue&type=script&lang=js"
import style0 from "./GiftCard.vue?vue&type=style&index=0&id=5c2d25e2&prod&lang=scss&scoped=true"
import style1 from "./GiftCard.vue?vue&type=style&index=1&id=5c2d25e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2d25e2",
  null
  
)

export default component.exports